import React from 'react';
import { useEmbedNavigate } from '../../../hooks/useEmbedNavigate';
import { ProgrammeResponse } from '../../../api/Api';
import { Icon } from '../../../assets/icons/Icon';
import styles from './TasksCard.module.scss';

interface TaskItem {
  id: string;
  title: string;
  image?: string;
}

interface TasksCardProps {
  programme?: ProgrammeResponse | null;
  tasks?: TaskItem[];
}

export const TasksCard: React.FC<TasksCardProps> = ({ programme, tasks = [] }) => {
  const navigate = useEmbedNavigate();

  const handleOpenDetails = () => {
    navigate('/initiative-details');
  };

  return (
    <div className={styles.tasksCard}>
      <div className={styles.tasksCard__header}>
        <div className={styles.tasksCard__titleRow}>
          <h3 className={styles.tasksCard__title}>Your tasks</h3>
          <span className={styles.tasksCard__badge}>{tasks.length}</span>
        </div>
        <button className={styles.tasksCard__viewMore}>View more</button>
      </div>

      <div className={styles.tasksCard__content}>
        {tasks.length > 0 ? (
          tasks.map((task) => (
            <div key={task.id} className={styles.tasksCard__task}>
              {task.image && (
                <div className={styles.tasksCard__imageWrapper}>
                  <img
                    src={task.image}
                    alt={task.title}
                    className={styles.tasksCard__image}
                  />
                </div>
              )}
              <p className={styles.tasksCard__taskName}>{task.title}</p>
              <button className={styles.tasksCard__taskButton} onClick={handleOpenDetails}>
                Open to view details
              </button>
            </div>
          ))
        ) : (
          <div className={styles.tasksCard__emptyState}>
            <Icon iconName="NoTasksIcon" width="5rem" height="5rem" />
            <p className={styles.tasksCard__emptyText}>
              You will be notified via email if new tasks are available.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TasksCard;
